import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper";
import useWindowSize from "hooks/useWindowSize";
import { Navigation, Pagination, Scrollbar, A11y } from "swiper";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { useEffect } from "react";
function SliderProduct({ product }) {
  const size = useWindowSize();
  const format = (src) => {
    src.substring(src.lastIndexOf(".") + 1);
  };

  useEffect(() => {
    document.querySelector(
      "#imageSlider"
    ).src = `http://marketgroup.tatdemo.ir/${product[0]}`;
    // product.otherMedia[0];
  }, [product]);
  const tests = ({ value, index }) => {
    document.querySelector(
      "#imageSlider"
    ).src = `http://marketgroup.tatdemo.ir/${value}`;
    // <div
    // className="tab-pane fade w-100 "
    // id={`pills-${index}`}
    // role="tabpanel"
    // aria-labelledby={`pills-${index}-tab`}
    // >
    //   <img
    //     className="round"
    //     src={value}
    //     style={{ width: "100%", height: "400px" }}
    //   ></img>
    // </div>;
  };
  const settings = {
    dots: false,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 3000,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 600,
        settings: {
          vertical: false,
          verticalSwiping: false,
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2.5,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        },
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          vertical: false,
          verticalSwiping: false,
        },
      },
      {
        breakpoint: 300,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          vertical: false,
        },
      },
    ],
  };

  return (
    <>
      <div className="px-2 d-flex align-items-center slider-product border-end justify-content-around">
        {/* tabs content */}

        <div
          // className="tab-content slider-content"
          // id="pills-tabContent"
          className="big-slide"
        >
          {/* {product.otherMedia.map((value, index) => { */}
          {/* return ( */}
          <div
            className=" w-100 "
            // tab-pane fade
            // id={`pills-${index}`}
            // role="tabpanel"
            // aria-labelledby={`pills-${index}-tab`}
          >
            <img
              id="imageSlider"
              className="round"
              // src={value}
              style={{ width: "100%", height: "400px" }}
            ></img>
          </div>
          {/* ); */}
          {/* })} */}
        </div>

        {/* tabs nav that slide */}

        <div className="thumbnails-container">
          <div className="slides-height">
            <Slider {...settings}>
              {product.map((value, index) => {
                console.log("value product", value);
                return (
                  <div ket={index}>
                    <img
                      className={` round img-slider`}
                      // nav-link
                      id={`pills-${index}-tab`}
                      // data-bs-toggle="pill"
                      // data-bs-target={`#pills-${index}`}
                      // type="button"
                      // role="tab"
                      // aria-controls={`pills-${index}`}
                      // aria-selected="true"
                      src={`http://marketgroup.tatdemo.ir/${value}`}
                      onClick={() => {
                        tests({ value, index });
                      }}
                    ></img>
                  </div>
                );
              })}
            </Slider>
          </div>
        </div>
      </div>
      {/* <img
                className={` round img-slider`}
                // nav-link
                id={`pills-${index}-tab`}
                // data-bs-toggle="pill"
                // data-bs-target={`#pills-${index}`}
                // type="button"
                // role="tab"
                // aria-controls={`pills-${index}`}
                // aria-selected="true"
                src={value}
                onClick={() => {
                  tests({ value, index });
                }}
              ></img> */}
    </>
  );
}

export default SliderProduct;
